module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showBackDrop) ? _c('div', {
    staticClass: "ui dimmer modals page",
    staticStyle: {
      "display": "block !important",
      "overflow-y": "scroll"
    },
    style: ({
      visibility: _vm.showBackDrop ? 'visible' : 'hidden',
      opacity: _vm.showBackDrop ? '1' : '0'
    }),
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "scale"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    staticClass: "ui modal active visibility",
    class: [_vm.size, _vm.type, _vm.isScroll ? 'scrolling' : ''],
    attrs: {
      "id": _vm.id
    },
    on: {
      "click": function($event) {
        _vm.clickContent($event)
      }
    }
  }, [_vm._t("default")], 2)])], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5cb26912!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 450
// module chunks = 28